import { useFormContext } from "react-hook-form";
import { Box, Divider, Grid, TextField, Typography } from "@mui/material";
import FieldSelectList from "components/forms/fields/FieldSelectList";

interface Props {
    tempWorker: any;
}

const NoteForm = ({tempWorker}: Props) => {
    const {register, control, formState: {errors}} = useFormContext<any>();

    return (
        <Box>
            <Box sx={{ mt: '1rem' }}>
                <Typography variant="h5">Divers</Typography>
                <Grid container spacing={2} columns={{xs: 1, sm: 2}}>
                    <Grid item xs={1}>
                        <FieldSelectList
                            control={control}
                            options={[[true, 'Oui'], [false, 'Non']]}
                            fieldName='use_coffreo'
                            labelId='use_coffreo'
                            label="Utilise coffreo ?"
                        />
                    </Grid>
                </Grid>
            </Box>
            <Divider sx={{my: '1rem'}} />
            <TextField
                id="comment"
                label="Commentaires"
                multiline
                rows={10}
                {...register('comment')}
                autoComplete='off'
                error={errors?.comment ? true : false}
                helperText={errors?.comment ? errors.comment.message as string : null}
            />
        </Box>
    );
};

export default NoteForm;
